import { render } from "./S136632.vue?vue&type=template&id=13f49408"
const script = {}
script.render = render

export default script